import React, { useEffect, useState } from 'react';
import ClassicHalfSizedBusStatusComponent from './ClassicHalfSizedBusStatusComponent/ClassicHalfSizedBusStatusComponent';
import { v4 as uuidV4 } from 'uuid';

export default function RotatingBusBanner({ busses, busBannerTick, bannerId }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Rotate through buses when parent triggers a tick
  useEffect(() => {
    if (Array.isArray(busses) && busses.length > 1) {
      setCurrentIndex((prev) => (prev + 1) % busses.length);
      //console.log(busBannerTick)
    }
  }, [busBannerTick, busses]);

  // No buses case
  if (!Array.isArray(busses) || busses.length === 0) {
    return (
      <ClassicHalfSizedBusStatusComponent
        key={uuidV4()}
        bannerId={bannerId}
        busData={{
          stopName: "Stop",
          routeNumber: "Bus",
          busColorHexValue: "#565a5c",
          predictionOne: "No arrivals",
          ctaErrorCode: "1"
        }}
      />
    );
  }

  const bus = busses[currentIndex];

  function buildBusData(bus) {
    let hasPredictions = false;
    if(bus.busPredictions && bus.busPredictions?.length > 0){
      hasPredictions = true;
    }
    const isTrueError = bus.myErrorCode && bus.myErrorCode !== "0" && !hasPredictions;

    if (isTrueError) {
      return {
        stopName: bus.stopName || "Error",
        routeNumber: bus.routeNumber || "",
        busColorHexValue: "#b71234", // red
        predictionOne: "",
        predictionTwo: "",
        ctaErrorCode: bus.myErrorCode,
      };
    }

    const getArrivalTime = (busPredictions, index) => {
      if (busPredictions.length == 0 && index == 0) return "No arrivals";
      if (busPredictions[index]){
        const val = busPredictions[index].countdown;
        return val === "DUE" || val === "DLY" ? "Due" : `${val}m`;
      }
      else{
        return "";
      }
    };

    return {
      stopName: bus.stopName,
      routeNumber: bus.routeNumber,
      routeDirection: bus.routeDirection,
      destination: bus.destination,
      busColorHexValue: bus.busColorHexValue || "#565a5c",
      predictionOne: getArrivalTime(bus.busPredictions, 0),
      predictionTwo: getArrivalTime(bus.busPredictions, 1) || "",
      predictionThree: getArrivalTime(bus.busPredictions, 2) || "",
      ctaErrorCode: bus.myErrorCode,
    };
  }

  const busData = buildBusData(bus);

  return (
    <ClassicHalfSizedBusStatusComponent
      key={uuidV4()}
      bannerId={bannerId}
      busData={busData}
    />
  );
}
